<template>
  <div
    class="modal fade"
    id="subirfactura"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-md" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">Subir Factura Digital</h5>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="row w-100 mx-0">
            <!-- Archivo 1: Factura -->
            <div class="col-12 px-2 mb-3">
              <label class="font-weight-bold text-center w-100">Factura</label>
              
              <!-- Si hay archivo 1 seleccionado -->
              <div v-if="previewUrl1" class="d-flex flex-column align-items-center justify-content-between p-3 position-relative" style="background-color: #f8f9fa; border-radius: 8px; border: 1px dashed #dee2e6; min-height: 250px;">
                <button type="button" class="btn btn-sm btn-danger position-absolute" style="top: -10px; right: -10px; border-radius: 50%; width: 30px; height: 30px; padding: 0; z-index: 10;" @click="removeFile('file1')" title="Remover archivo">
                  <i class="fas fa-times"></i>
                </button>
                <div class="mb-2 text-dark font-weight-bold w-100 text-center" style="font-size: 0.9em;">
                  <i class="fas fa-file-invoice mr-1"></i> Factura Seleccionada
                </div>
                
                <div v-if="esImagen(file1Name)" class="d-flex w-100 align-items-center justify-content-center flex-grow-1" style="transition: transform 0.2s;" onmouseover="this.style.transform='scale(1.02)'" onmouseout="this.style.transform='scale(1)'">
                   <img :src="previewUrl1" alt="Vista previa" style="max-width: 100%; max-height: 180px; border-radius: 6px; box-shadow: 0 4px 8px rgba(0,0,0,0.1); object-fit: contain;">
                </div>
                <div v-else class="d-flex flex-column w-100 mt-2 align-items-center justify-content-center flex-grow-1 text-dark" style="transition: transform 0.2s;" onmouseover="this.style.transform='scale(1.02)'" onmouseout="this.style.transform='scale(1)'">
                   <i class="fas fa-file-invoice fa-4x mb-2"></i>
                </div>
                
                <span class="mt-3 text-muted w-100 text-center" style="word-break: break-all; font-size: 0.85em; font-weight: 500;">
                  {{ file1Name }}
                </span>
              </div>
              
              <!-- Si NO hay archivo 1 -->
              <div v-else class="d-flex flex-column align-items-center justify-content-center p-4 position-relative " style="background-color: #fcfcfc; border-radius: 8px; border: 2px dashed #bbbbbb; cursor: pointer; transition: background-color 0.2s; min-height: 250px;" onmouseover="this.style.backgroundColor='#f0f0f0'" onmouseout="this.style.backgroundColor='#fcfcfc'" @click="triggerInput('file1')">
                <i class="fas fa-cloud-upload-alt fa-3x text-muted mb-3"></i>
                <span class="font-weight-bold text-muted text-center">Click para buscar Factura</span>
                <span class="text-muted text-center" style="font-size: 0.8em;">Solo PDF</span>
              </div>
              <!-- Input oculto -->
              <input type="file" ref="file1" class="d-none" @change="handleFileUpload($event, 'file1')" accept=".pdf" />
            </div>

            <!-- Archivo 2: Anexo / Contraseña -->
            <div class="col-12 px-2 mb-3">
              <label class="font-weight-bold text-center w-100">Contraseña / Anexo</label>
              
              <!-- Si hay archivo 2 seleccionado -->
              <div v-if="previewUrl2" class="d-flex flex-column align-items-center justify-content-between p-3 position-relative" style="background-color: #f8f9fa; border-radius: 8px; border: 1px dashed #dee2e6; min-height: 250px;">
                <button type="button" class="btn btn-sm btn-danger position-absolute" style="top: -10px; right: -10px; border-radius: 50%; width: 30px; height: 30px; padding: 0; z-index: 10;" @click="removeFile('file2')" title="Remover archivo">
                  <i class="fas fa-times"></i>
                </button>
                <div class="mb-2 text-dark font-weight-bold w-100 text-center" style="font-size: 0.9em;">
                  <i class="fas fa-file-alt mr-1"></i> Anexo Seleccionado
                </div>
                
                <div v-if="esImagen(file2Name)" class="d-flex w-100 align-items-center justify-content-center flex-grow-1" style="transition: transform 0.2s;" onmouseover="this.style.transform='scale(1.02)'" onmouseout="this.style.transform='scale(1)'">
                   <img :src="previewUrl2" alt="Vista previa anexo" style="max-width: 100%; max-height: 180px; border-radius: 6px; box-shadow: 0 4px 8px rgba(0,0,0,0.1); object-fit: contain;">
                </div>
                <div v-else class="d-flex flex-column w-100 mt-2 align-items-center justify-content-center flex-grow-1 text-dark" style="transition: transform 0.2s;" onmouseover="this.style.transform='scale(1.02)'" onmouseout="this.style.transform='scale(1)'">
                   <i class="fas fa-file-alt fa-4x mb-2"></i>
                </div>
                
                <span class="mt-3 text-muted w-100 text-center" style="word-break: break-all; font-size: 0.85em; font-weight: 500;">
                  {{ file2Name }}
                </span>
              </div>
              
              <!-- Si NO hay archivo 2 -->
              <div v-else class="d-flex flex-column align-items-center justify-content-center p-4 position-relative" style="background-color: #fcfcfc; border-radius: 8px; border: 2px dashed #bbbbbb; cursor: pointer; transition: background-color 0.2s; min-height: 250px;" onmouseover="this.style.backgroundColor='#f0f0f0'" onmouseout="this.style.backgroundColor='#fcfcfc'" @click="triggerInput('file2')">
                <i class="fas fa-plus-circle fa-3x text-muted mb-3"></i>
                <span class="font-weight-bold text-muted text-center">Añadir Anexo</span>
                <span class="text-muted text-center" style="font-size: 0.8em;">Solo PDF</span>
              </div>
              <!-- Input oculto -->
              <input type="file" ref="file2" class="d-none" @change="handleFileUpload($event, 'file2')" accept=".pdf" />
            </div>
          </div>
          
          <hr class="mt-2 mb-4">
          <div class="row mx-0">
            <div class="col-12 px-2">
              <div class="d-flex flex-row justify-content-between w-100">
                <button 
                    @click="SubirImagenScan()"
                    class="btn btn-success w-50 py-3 mr-2 font-weight-bold"
                    :disabled="!archivosSuficientes"
                >
                    <i class="fa fa-save mr-1"></i> Confirmar Subida
                </button>
                <button data-dismiss="modal" type="button" class="btn btn-secondary w-50 py-3 ml-2 font-weight-bold" @click="resetForm()">
                  <i class="fas fa-times mr-1"></i> Cancelar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DynamicService from "@/services/commons/DynamicService";
import Notifications from "@/notifications/notifications";

export default {
  name: 'SubirFacturaScanModalComponent',
  inject: {
    refreshRecepcion: {
      default: null
    }
  },
  components: {},
  data() {
    return {
      uploadFile1: null,
      uploadFile2: null,
      previewUrl1: null,
      previewUrl2: null,
      file1Name: '',
      file2Name: '',
    };
  },
  props: {
    current: {
      type: Object,
      required: false,
      default: () => ({})
    }
  },
  computed: {
    esReemplazo() {
      // Determinar si ya existen archivos en la base de datos para esta factura
      if (!this.current) return false;
      const t1 = typeof this.current.archivo === 'string' && this.current.archivo.trim() !== '';
      const t2 = typeof this.current.archivo_2 === 'string' && this.current.archivo_2.trim() !== '';
      return t1 || t2;
    },
    archivosSuficientes() {
      if (this.esReemplazo) {
        // En reemplazo, con subir al menos un archivo basta
        return !!(this.uploadFile1 || this.uploadFile2);
      } else {
        // Si es una subida inicial, ambos son estrictamente obligatorios
        return !!(this.uploadFile1 && this.uploadFile2);
      }
    }
  },
  mounted() {
    // Escuchar cuando el modal se cierra para limpiar los campos
    $('#subirfactura').on('hidden.bs.modal', this.resetForm);
  },
  beforeDestroy() {
    $('#subirfactura').off('hidden.bs.modal', this.resetForm);
  },
  methods: {
    triggerInput(fileId) {
      if (this.$refs[fileId]) {
        this.$refs[fileId].click();
      }
    },
    esImagen(filename) {
      if (!filename) return false;
      const extension = filename.split('.').pop().toLowerCase();
      return ['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp'].includes(extension);
    },
    handleFileUpload(event, fileId) {
      const file = event.target.files[0];
      // Resetear el input para permitir re-selección tras un error
      event.target.value = '';

      if (!file) {
        this.removeFile(fileId);
        return;
      }

      // Validación estricta: solo PDF (por tipo MIME y extensión)
      const esPDF = file.type === 'application/pdf' || file.name.toLowerCase().endsWith('.pdf');
      if (!esPDF) {
        Notifications.alert.error(
          'Archivo no permitido',
          'Solo se permiten archivos PDF. Por favor selecciona un archivo con extensión .pdf'
        );
        this.removeFile(fileId);
        return;
      }

      if (fileId === 'file1') {
        this.uploadFile1 = file;
        this.file1Name = file.name;
        if (this.previewUrl1) URL.revokeObjectURL(this.previewUrl1);
        this.previewUrl1 = URL.createObjectURL(file);
      } else if (fileId === 'file2') {
        this.uploadFile2 = file;
        this.file2Name = file.name;
        if (this.previewUrl2) URL.revokeObjectURL(this.previewUrl2);
        this.previewUrl2 = URL.createObjectURL(file);
      }
    },
    removeFile(fileId) {
      if (fileId === 'file1') {
        this.uploadFile1 = null;
        this.file1Name = '';
        if (this.previewUrl1) {
          URL.revokeObjectURL(this.previewUrl1);
          this.previewUrl1 = null;
        }
        if (this.$refs.file1) this.$refs.file1.value = '';
      } else if (fileId === 'file2') {
        this.uploadFile2 = null;
        this.file2Name = '';
        if (this.previewUrl2) {
          URL.revokeObjectURL(this.previewUrl2);
          this.previewUrl2 = null;
        }
        if (this.$refs.file2) this.$refs.file2.value = '';
      }
    },
    resetForm() {
      this.removeFile('file1');
      this.removeFile('file2');
    },
    SubirImagenScan() {
      let self = this;
      self.current.fecha_revision = "";

      if (!this.archivosSuficientes) {
        let mensaje = this.esReemplazo 
          ? "Debe seleccionar al menos un archivo para subir o reemplazar."
          : "La subida de la Factura y el Anexo / Contraseña son ambos obligatorios al subir por primera vez.";
        
        Swal.fire(
          "No permitido",
          mensaje,
          "warning"
        );
        return false;
      }
      this.current.cargando = true;

      DynamicService.updateMultipleFilesWithPost(
        "wms",
        "facturas",
        this.current,
        this.uploadFile1, // File 1
        this.uploadFile2 // File 2
      )
        .then((res) => {
          this.resetForm(); // Limpiar inputs y urls generadas
          this.current.cargando = false;

          $("#subirfactura").modal("hide");
          Notifications.alert.success(
            "Subir Factura Digital",
            "Realizado correctamente"
          );
          if (this.refreshRecepcion) {
            this.refreshRecepcion();
          }
          this.$emit('uploaded');
        })
        .catch((error) => {
          this.current.cargando = false;
          const msg = (error && error.response && error.response.data && error.response.data.detail) || "No se pudo enviar el archivo";
          Notifications.alert.error(
            "Subir Factura Digital",
            msg
          );
        });
    },
  },
};
</script>

<style scoped>
/* Estilos para el botón interno ("Browse...") de los inputs de tipo archivo */
input[type="file"]::file-selector-button {
  background-color: #007bff; /* Color primario de la app */
  color: white;
  border: none;
  padding: 1rem 1rem;
  margin-top: -0.375rem;
  margin-left: -1rem;
  margin-bottom: -0.375rem;
  margin-right: 0.75rem;
  border-right: 1px solid #ced4da;
  border-radius: 0.25rem 0 0 0.25rem;
  cursor: pointer;
  transition: background-color 0.2s ease-in-out;
}

input[type="file"]::file-selector-button:hover {
  background-color: #0056b3;
}

/* Soporte para Firefox y navegadores más antiguos */
input[type="file"]::-webkit-file-upload-button {
  background-color: #007bff;
  color: white;
  border: none;
  padding: 0.375rem 0.75rem;
  margin-top: -0.375rem;
  margin-left: -0.375rem;
  margin-bottom: -0.375rem;
  margin-right: 0.75rem;
  border-right: 1px solid #ced4da;
  border-radius: 0.25rem 0 0 0.25rem;
  cursor: pointer;
  transition: background-color 0.2s ease-in-out;
}

input[type="file"]::-webkit-file-upload-button:hover {
  background-color: #0056b3;
}
</style>
